import React, { useState } from 'react';
import { Select, Steps } from 'antd';
import { EnvironmentOutlined, StepForwardOutlined } from '@ant-design/icons';
import './EqOnboarding.scss';
import { EqInput } from '../custom/eqInput/EqInput';
import EqButton from '../custom/eqButton/EqButton';
import { useNavigate } from 'react-router-dom';
import { EqLocation } from '../custom/eqLocation/EqLocation';
import { getEmailFromToken } from '../shared/Common';
import { EqLocationType } from '../shared/enums';
import { ISelectProps } from '../shared/Interfaces';
import { useTranslation } from 'react-i18next';
import EqSelect from '../custom/eqSelect/EqSelect';

const { Option } = Select;
const { Step } = Steps;

const EqOnBoarding = () => {
      const currentUserEmail = getEmailFromToken();
        const { t } = useTranslation();
    
  const [step, setStep] = useState(1);
  const [address, setAddress] = useState('');
  const [activity, setActivity] = useState<number>() ;
  const navigate = useNavigate();
  const [locationModalVisible, setLocationModalVisible] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState<any>(null);
  
  const nextStep = () => {
    if (step === 1) {
      setStep(2);
    } else if (step === 2) {
      // Redirect based on activity number
      switch (activity) {
        case 1: // event
          navigate('/school/activityBoard?tab=2');
          break;
        case 2: // training
          navigate('/school/activityBoard?tab=1');
          break;
        case 3: // ridingCourse
          navigate('/school/trainingCourse');
          break;
        default:
          navigate('/school/home');
          break;
      }
    }
  };
  

      const activitySelectProps: ISelectProps = {
         
          classNames: "extra-height",
          placeholder: `${t("selectActivity")}`,
          options: Object.entries({
              1: 'event',
              2: 'training',
              3: 'ridingCourse',
          })
              .filter((key) => !isNaN(Number(key)))
              .map((e) => ({ key: parseInt(e[0]), value: `${t(e[1] as string)}` })),
          // options: currencyOptions,
          defaultSelectedValue: activity,
  
          changeFunc: (value: string) => {
            
              let type: number = +value;
              setActivity(type);
          },
      };
  

  const skip = () => navigate('/school/home');

  const steps = [
    { title: 'Location' },
    { title: 'Activity' },
    { title: 'Done' },
  ];
  

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
      <div className="onboarding-card">

      <h2>{step === 1 ? t("whereIsYourSchool") : step === 2 ? t("getStarted") : 'All Set!'}</h2>
  <p>
    {step === 1
      ? t("helpStudentsFindSchool")
      : step === 2
      ? t("createYourFirstActivity")
      : "You're ready to go. Let's get started."}
  </p>

  <div className="register-steps">
    <Steps current={step-1} labelPlacement="vertical">
      {steps.map((_, index) => <Step key={index} />)}
    </Steps>
  </div>

{step === 1 && (
    // <EqInput
    //   placeholder="Address"
    //   suffix={<EnvironmentOutlined />}
    //   value={address}
    //   onChange={(e: any) => setAddress(e.target.value)}
    //   style={{ margin: '20px 0', width: '300px' }}
    // />

    <>
    <EqInput
      placeholder={t("address")}
      suffix={<EnvironmentOutlined />}
      value={selectedLocation?.description || ''}
      onClick={() => setLocationModalVisible(true)}
      readOnly
      style={{ margin: '20px 0', width: '300px', cursor: 'pointer' }}
    />

    <EqLocation
      visible={locationModalVisible}
      locationType={EqLocationType.Home}  // <-- Send this to override default
      okClicked={(locationSummary, locationDetail) => {

        setSelectedLocation(locationSummary); // Set the selected location summary (to display)
        setLocationModalVisible(false);
        // You can also store locationDetail if needed
      }}
      cancelClicked={() => setLocationModalVisible(false)}
      title={t("selectLocation")}
      email={currentUserEmail} // Replace with actual email or user prop
    />
  </>
)}

{step === 2 && (

<div style={{ margin: '20px 0', padding:'0 20px' } }>

<EqSelect {...activitySelectProps} />
</div>

  )}

<EqButton 
  type="primary" 
  onClick={nextStep} 
  style={{ marginTop: '20px' }} 
  disabled={(step === 1 && !selectedLocation) || (step === 2 && !activity)}
>
  {step < 3 ? t("next") : t('finish')}
</EqButton>
  <EqButton type="link" onClick={skip} icon={<StepForwardOutlined />} style={{ marginLeft: 10 }}>
    {t("skip")}
  </EqButton>
      </div>
    </div>
  );
};

export default EqOnBoarding;
